import { RouteObject } from "react-router-dom";
import PerformanceLanding from "./components/landing/landing";

export interface PerformanceRoute
  extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: PerformanceRoute[];
}

export const performanceRoutes: PerformanceRoute[] = [
 {
    path: "call-center/performance",
    element: <PerformanceLanding />,
  },
];
